/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Secondlanguage1Inputs */

const en__field_secondlanguage1 = /** @type {(inputs: _Field_Secondlanguage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Second language`)
};

/**
* | output |
* | --- |
* | "Second language" |
*
* @param {_Field_Secondlanguage1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const _field_secondlanguage1 = /** @type {((inputs?: _Field_Secondlanguage1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Secondlanguage1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en__field_secondlanguage1(inputs)
});
export { _field_secondlanguage1 as "_field_secondLanguage" }